import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { TAFBookS3Service } from './taf-book-s3.service';
import { ITAFBookS3 } from './taf-book-s3-list';

import {DataTable} from 'primeng/primeng';
import {Column} from 'primeng/primeng';
import {Header} from 'primeng/primeng';
import {Button} from 'primeng/primeng';


@Component({
    //templateUrl: 'app/system-management/tafbooks/taf-book-s3/taf-book-s3.component.html',
    template: require('./taf-book-s3.component.html'),
    directives: [ROUTER_DIRECTIVES,DataTable,Column, Header],
    
})

export class TAFBookS3Component implements OnInit, OnDestroy{
    pageTitle: string = 'TAF BOOK s3';
    errorMessage: string;
    tafBookS3Arr: ITAFBookS3;
   
    constructor(private route: ActivatedRoute,
                private router: Router,
                private _tafBooks3Service: TAFBookS3Service) {
                    
    }

    ngOnInit(): void{
        this._tafBooks3Service.getTAFBookS3()
         .subscribe(
                tafBookS3Arr => this.tafBookS3Arr = tafBookS3Arr,
                error =>  this.errorMessage = <any>error);
    }

    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}



/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-s3/taf-book-s3.component.ts
 **/